<template>
  <div class="typing-indicator">
    <div class="typing-indicator-content">
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "TypingIndicator"
};
</script>

<style scoped lang="less">
.typing-indicator {
  display: flex;
  margin: 10px;
  max-width: 90%;
  float: left;
  
  .typing-indicator-content {
    background: #edf3ff;
    padding: 14px 20px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 60px;
    
    .dot {
      width: 8px;
      height: 8px;
      background: #1d6aff;
      border-radius: 50%;
      animation: typing 1.4s infinite;
      
      &:nth-child(1) {
        animation-delay: 0s;
      }
      
      &:nth-child(2) {
        animation-delay: 0.2s;
      }
      
      &:nth-child(3) {
        animation-delay: 0.4s;
      }
    }
  }
}

@keyframes typing {
  0%, 60%, 100% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  30% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
